var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateDetails',{attrs:{"get-function":_vm.getWallet,"data":_vm.wallet,"loading":_vm.walletLoading}},[_c('PageBack'),_c('Form',{ref:"form",attrs:{"title":_vm.$t('wallet.add'),"model":_vm.model,"fields":_vm.fields,"action":_vm.addToWallet,"successMsg":_vm.$t('wallet.add_success'),"init-on-success":true},on:{"success":_vm.onSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }